var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F2F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9992 10.7992C14.9182 10.7992 10.7992 14.9182 10.7992 19.9992C10.7992 25.0802 14.9182 29.1992 19.9992 29.1992C25.0802 29.1992 29.1992 25.0802 29.1992 19.9992C29.1992 14.9182 25.0802 10.7992 19.9992 10.7992ZM9.19922 19.9992C9.19922 14.0345 14.0345 9.19922 19.9992 9.19922C25.9639 9.19922 30.7992 14.0345 30.7992 19.9992C30.7992 25.9639 25.9639 30.7992 19.9992 30.7992C14.0345 30.7992 9.19922 25.9639 9.19922 19.9992Z",
    fill: "#4D4D4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9992 19.354C20.441 19.354 20.7992 19.7122 20.7992 20.154L20.7992 24.1921C20.7992 24.6339 20.4411 24.9921 19.9992 24.9921C19.5574 24.9921 19.1992 24.6339 19.1992 24.1921L19.1992 20.154C19.1992 19.7122 19.5574 19.354 19.9992 19.354Z",
    fill: "#4D4D4D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9041 16.1564C20.9041 16.6561 20.499 17.0612 19.9992 17.0612C19.4995 17.0612 19.0944 16.6561 19.0944 16.1564C19.0944 15.6566 19.4995 15.2515 19.9992 15.2515C20.499 15.2515 20.9041 15.6566 20.9041 16.1564Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationInfo);
export default __webpack_public_path__ + "static/media/notification-info.28043e150eb72f484670664c438ac8dd.svg";
export { ForwardRef as ReactComponent };